export default __webpack_public_path__ + "static/media/V2_Aviso_LegalAPP_AECE.7c227610.pdf";